import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchXtdByGroupProps = {
  clusters?: Array<string>;
  partners?: Array<number>;
  origami?: string;
  am?: Array<string>;
};
export type FetchXtdByGroup = (filters: FetchXtdByGroupProps) => void;

const fetchXtdByGroup = ({
  clusters = [],
  partners = [],
  origami,
  am = [],
}: FetchXtdByGroupProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    cluster: clusters.length ? "'" + clusters.join("','") + "'" : null,
    partner: partners.join(","),
    enable_origami: origami,
    account_manager: am.length ? "'" + am.join("','") + "'" : null,
  };
  await fetchReport("xtd_by_group", dispatch, params);
};

export default fetchXtdByGroup;
